import { gql } from '@apollo/client';

export const ADD_SURVEY_RESPONSE_MUTATION = gql`
    mutation AddNpsSurveyResponse($input: SurveyInputDto!) {
        addNpsSurveyResponse(input: $input) {
            message
        }
    }
`;
